import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import { Icon } from "@/components/common";
import { DefaultComponentProps } from "@/interfaces/common";

interface Props extends DefaultComponentProps {
  isOpen: boolean;
  onClose?: () => void;
  hasCloseButton?: boolean;
  hasOverlay?: boolean;
  isOverlayCloseable?: boolean;
}

export const ModalBase = ({
  children,
  className,
  isOpen,
  onClose,
  hasCloseButton,
  hasOverlay = true,
  isOverlayCloseable = true,
}: Props): JSX.Element => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed left-0 top-0 z-[999] flex h-full w-full items-center justify-center backdrop-blur-sm"
        >
          <div
            role="none"
            className={clsx(["absolute h-full w-full", { "bg-[#24242426] blur-sm": hasOverlay }])}
            onClick={isOverlayCloseable ? onClose : undefined}
          />

          <motion.div
            initial={{ scale: 0.75 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.75 }}
            className={clsx("relative z-50 min-w-72 bg-background-primary shadow-box-primary sm:min-w-96", className)}
          >
            {hasCloseButton && (
              <Icon name="Close" className="absolute right-3 top-3 cursor-pointer text-gray" onClick={onClose} />
            )}

            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
